import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a1668682-6cd0-4608-a6a8-d20136862eb0/artifacts/fhi5ktps_IMG_9483.jpeg";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role !== "admin") {
        toast.error("Yönetici yetkiniz yok");
        return;
      }
      toast.success("Hoş geldiniz!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Admin Girişi" />
      <div className="min-h-screen bg-[#030f26] flex items-center justify-center p-6 text-[#fdfbf7]">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-3 justify-center mb-10">
            <img src={LOGO_URL} alt="Wünberg" className="w-12 h-12 object-cover border border-white/10" />
            <div>
              <div className="font-serif text-xl">Wünberg</div>
              <div className="text-[10px] uppercase tracking-widest text-[#d4af37]">Admin Paneli</div>
            </div>
          </Link>
          <div className="wb-card p-8">
            <h1 className="wb-h3">Yönetici Girişi</h1>
            <p className="text-sm text-[#a0aabf] mt-2">Sadece yetkili kullanıcılar erişebilir.</p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form" autoComplete="off">
              <input
                type="email"
                className="wb-input"
                placeholder="E-posta"
                required
                autoComplete="off"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="admin-login-email"
              />
              <input
                type="password"
                className="wb-input"
                placeholder="Şifre"
                required
                autoComplete="new-password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="admin-login-password"
              />
              <button type="submit" disabled={loading} className="wb-btn-primary w-full" data-testid="admin-login-submit">
                {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
              </button>
            </form>
            <Link to="/" className="text-xs text-[#a0aabf] hover:text-[#d4af37] mt-6 inline-block">← Siteye dön</Link>
          </div>
        </div>
      </div>
    </>
  );
}
